export default __webpack_public_path__ + "static/card-8-d025cabab48a0c2d041b313ac6017edb.png";